import { Action } from 'redux';
import { FileInfo } from '@dev/ee-api/ee-api-models';

export enum UploadActionTypes {
    UPLOAD_FILES = '@@upload/UPLOAD_FILES',
    UPLOAD_MEDIA_FILES = '@@uploadmedia/UPLOAD_FILES',
    UPLOAD_FILES_START = '@@upload/UPLOAD_FILES_START',
    UPLOAD_ERROR = '@@upload/UPLOAD_ERROR',
    UPLOAD_SUCCESS = '@@upload/UPLOAD_SUCCESS',
    UPLOAD_FILE_PROGRESS_UPDATE = '@@upload/UPLOAD_FILE_PROGRESS_UPDATE',
    DELETE_FILE = '@@upload/DELETE_FILE',
    SET_ANALYTICS_OPEN = '@@upload/SET_ANALYTICS_OPEN',
}

export interface UploadFilesAction extends Action {
    type: UploadActionTypes.UPLOAD_FILES;
    payload: {
        file: File;
        expiresAfterDays?: number;
    };
}

export interface UploadFilesActionMedia extends Action {
    type: UploadActionTypes.UPLOAD_MEDIA_FILES;
    payload: {
        file: File;
        expiresAfterDays?: number;
    };
}

export interface UploadFilesStartAction extends Action {
    type: UploadActionTypes.UPLOAD_FILES_START;
}

export interface UploadFilesErrorAction extends Action {
    type: UploadActionTypes.UPLOAD_ERROR;
}

export interface UploadFilesSuccessAction extends Action {
    type: UploadActionTypes.UPLOAD_SUCCESS;
    payload: {
        fileuploaded: FileInfo;
    };
}

export interface UploadFilesUpdateProgressAction extends Action {
    type: UploadActionTypes.UPLOAD_FILE_PROGRESS_UPDATE;
    payload: {
        progress: number;
    };
}

export interface DeleteUploadedFileAction extends Action {
    type: UploadActionTypes.DELETE_FILE;
    payload: {
        fileuploaded: boolean;
    };
}

export interface SetAnalyticsOpenAction extends Action {
    type: UploadActionTypes.SET_ANALYTICS_OPEN;
    payload: {
        isAnalyticsOpen: boolean;
    };
}

export interface UploadState {
    uploading: boolean;
    progress: number;
    file?: File;
    fileuploaded?: FileInfo;
    isAnalyticsOpen?: boolean;
}

export default UploadState;
